<template>
  <md-card-content :class="{'overflow-initial' : postPreview !== null}">
    <text-content :post="post" :post-preview="postPreview"></text-content>
    <image-content v-if="post.medias && post.medias.length !== 0 &&
    (post.type==='IMAGE' || post.type==='ALBUM' || post.type==='UPDATE_GROUP_AVATAR' || post.type==='UPDATE_USER_AVATAR' || post.type==='UPDATE_USER_WALLPAPER')"
                   :mediaObject="{post_id: post.id, media_count: post.media_count, mediaList: post.medias, type: post.type}">
    </image-content>
    <file-content v-if="post.medias && post.medias.length !== 0 && (post.type==='FILE')" :files="post.medias"></file-content>
    <poll-content v-if="pollData != null" :poll-data="pollData"></poll-content>
  </md-card-content>
</template>

<script>
import TextContent from "./Content/TextContent";
import FileContent from "./Content/FileContent";
import ImageContent from "./Content/ImageContent";
import VideoContent from "./Content/VideoContent";
import PollContent from "./Content/PollContent";
export default {
  name: "post-content",
  components: {ImageContent, FileContent, TextContent, PollContent},
  props: {
    post: {
      type: Object,
      default: () => ({}),
    },
    pollData: {
      type: Object,
      default: null,
    },
    postPreview: {
      type: Object,
      default: null,
    },
    isPostPreview: {
      type: Boolean,
      default: false,
    }
  },
};
</script>

<style lang="css"></style>
